import {get} from '@servicenow/ui-internal';
import {isSelector} from '../property-selectors';

/**
 * Utility function to get resolved value with a path
 * @param resolvedValue
 * @param path
 * @returns {*}
 */
export default function getResolvedValue(resolvedValue, path, propertyDef) {
	if (resolvedValue && path) {
		// eslint-disable-next-line no-param-reassign
		resolvedValue = get(resolvedValue, path);
	}

	if (
		resolvedValue === undefined &&
		propertyDef?.default !== undefined &&
		!isSelector(propertyDef?.default)
	) {
		return propertyDef.default;
	}

	return resolvedValue;
}
